import TextInput from "../../common/TextInput";
import React from "react";
import glamorous from "glamorous";

const Label = glamorous.label({
  fontFamily: "JWSansBold",
  textTransform: "uppercase",
  paddingBottom: "10px",
  display: "block",
  marginTop: "20px"
});

const RemainingCharacterLabel = glamorous.span({
  position: "relative",
  marginTop: "-30px",
  marginRight: "20px",
  float: "right",
  color: "#555",
  fontSize: "14px"
});

const Wrapper = glamorous.div({
  marginTop: "15px",
  marginBottom: "15px"
});

const InputField = ({text, onChange, label}) => {
  const charactersRemaining = text.maxLength && text.maxLength - text.value.length;

  return (
    <Wrapper>
      <Label>{label}</Label>
      <div>
        <TextInput maxLength={text.maxLength} value={text.value} onChange={onChange} placeholder={text.placeholder}/>
        <RemainingCharacterLabel>{charactersRemaining}</RemainingCharacterLabel>
      </div>
    </Wrapper>
  );
};

export default InputField;



// WEBPACK FOOTER //
// ./src/components/areas/EditorTemplate/InputField.js